module.exports = __webpack_public_path__ + "static/media/college_4.56d53980.jpg";